import { format, isThisYear, isToday, isValid, isYesterday } from 'date-fns';

const DATE_FNS_FORMAT = 'EEEE, MMM do';
const DATE_FNS_FORMAT_WITH_YEAR = 'MMM do, yyyy';

export default (messageDateMs: string): string => {
  const messageDate = new Date(+messageDateMs);

  if (!isValid(messageDate)) {
    return '';
  }

  if (isYesterday(messageDate)) {
    return 'Yesterday';
  }

  if (isToday(messageDate)) {
    return 'Today';
  }

  const formatString = isThisYear(messageDate) ? DATE_FNS_FORMAT : DATE_FNS_FORMAT_WITH_YEAR;
  return format(messageDate, formatString);
};
